<template>
  <div>
    <b-modal visible      
             centered
             no-close-on-backdrop
             no-close-on-esc
             no-close
             hide-header
             hide-header-close
             header-bg-variant="secondary"
             header-text-variant="light"
             hide-footer>
      <template slot="modal-header">
        <div class="row ">
          <div class="col">
            <h5 v-if="propTipo == 'cumprir'"
                class="ProtocoloForm--header">
              Cumprir protocolo
            </h5>
            <h5 v-if="propTipo == 'cancelar'"
                class="ProtocoloForm--header">
              Cancelar protocolo
            </h5>
          </div>
        </div>
      </template>
      <div class="row">
        <div v-if="propTipo == 'cumprir'"
             class="col">
          <label for="data_cumprimento"
                 class="label">
            Data cumprimento
          </label>
          <input v-model="form.data_cumprimento"
                 v-validate="`date_format:yyyy-MM-dd|max_date: ${new Date()}`"
                 type="date"
                 name="data_cumprimento"
                 :class="{ 'is-invalid text-danger': errors.has('data_cumprimento') }"
                 class="form-control form-control-sm">
          <small v-if="errors.has('data_cumprimento')"
                 class="text-danger text-bold">
            {{ errors.first('data_cumprimento') }}
          </small>
        </div>
        <div v-if="propTipo == 'cancelar'"
             class="col">
          <div>
            <div v-if="stepsCancelamento === 1"
                 class="d-flex flex-wrap mb-3">
              <label class="col-12"><strong>{{ `Passo ${stepsCancelamento} de 2` }}</strong></label>
              <span class="col-12">{{ `Deseja cancelar o protocolo ${propProtocolo.numero}/${propProtocolo.ano}? Ele não será excluído do Sofia-Rei.` }}</span>
              <div class="col-12 d-flex justify-content-center mt-3">
                <button class="btn btn-sm btn-danger mr-2 pl-4 pr-4"
                        @click="$emit('onClose')">
                  Não
                </button>
                <button class="btn btn-sm btn-secondary ml-4 pl-4 pr-4"
                        @click="() => stepsCancelamento = 2">
                  Sim
                </button>
              </div>
            </div>
            <div v-if="stepsCancelamento === 2">
              <label for="data_cumprimento"
                     class="label">
                Data cancelamento
              </label>
              <input v-model="form.data_cancelamento"
                     v-validate="`date_format:yyyy-MM-dd|max_date: ${new Date()}`"
                     type="date"
                     name="data_cancelamento"
                     :class="{ 'is-invalid text-danger': errors.has('data_cancelamento') }"
                     class="form-control form-control-sm">
              <small v-if="errors.has('data_cancelamento')"
                     class="text-danger text-bold">
                {{ errors.first('data_cancelamento') }}
              </small>
              <b-form-group
                label="Motivo de cancelamento"
                label-for="textarea-formatter"
                class="mb-2 mt-3">
                <b-form-textarea
                  id="textarea-formatter"
                  v-model="form.motivo_cancelamento"
                  rows="4"
                  :formatter="formatter" />
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <hr v-if="propTipo == 'cancelar' && stepsCancelamento === 2 || propTipo == 'cumprir'">
      <div v-if="propTipo == 'cancelar' && stepsCancelamento === 2 || propTipo == 'cumprir'"
           class="row">
        <div class="col text-right">
          <button class="btn btn-sm btn-outline-secondary"
                  @click="$emit('onClose')">
            Voltar
          </button>
          <button v-if="propTipo == 'cancelar'"
                  class="btn btn-sm btn-primary active ml-2"
                  @click="cancelarProtocolo(propProtocolo)">
            Cancelar
          </button>
          <button v-if="propTipo == 'cumprir'"
                  class="btn btn-sm btn-success active ml-2"
                  @click="cumprirProtocolo(propProtocolo)">
            Cumprir
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* services */
  import ProtocolosService from "@/services/Protocolos"

  /* libraries */
  import moment from "moment"

  export default {
    name: "ProtocoloAcoes",
    props: {
      propTipo: {
        type: String,
        default: () => null
      },
      propProtocolo: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        stepsCancelamento: 1,
        form: {
          data_cumprimento: moment().format('YYYY-MM-DD'),
          data_cancelamento: moment().format('YYYY-MM-DD'),
          motivo_cancelamento: null,
          protocolo_id: null
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.form.protocolo_id = this.propProtocolo.id
      },
      async cumprirProtocolo (protocolo) {
        try {
          const validate = await this.$validator.validate()
          if (!validate) return

          objSwal.question.title = `Cumprir protocolo '${ protocolo.numero }'?`
          objSwal.question.text = ``
          const status = await Swal.fire(objSwal.question)

          // confirme a exclusão
          if (status.value) {
            loader({ active: true, text: 'Cumprindo protocolo...' })
            await ProtocolosService.cumprir({ ...protocolo, data_cumprimento: this.form.data_cumprimento })
            objSwal.success.title = 'Protocolo cumprido!'
            Swal.fire(objSwal.success)
            this.$emit('onReload')
          }
        } finally {
          loader({ active: false, text: '' })
        }
      },
      async cancelarProtocolo (protocolo) {
        const payload = {
          ...protocolo,
          data_cancelamento: this.form.data_cancelamento, 
          motivo_cancelamento: this.form.motivo_cancelamento
        }
        try {
          const validate = await this.$validator.validate()
          if (!validate) return

          objSwal.question.title = `Cancelar protocolo '${ protocolo.numero }'?`
          objSwal.question.text = ``
          const status = await Swal.fire(objSwal.question)

          // confirme a exclusão
          if (status.value) {
            loader({ active: true, text: 'Cancelando protocolo...' })
            await ProtocolosService.cancelar(payload)
            objSwal.success.title = 'Protocolo cancelado!'
            Swal.fire(objSwal.success)
            this.$emit('onCancelarProtocolo', payload)
            this.$emit('onReload')
          }
        } finally {
          loader({ active: false, text: '' })
        }
      }
    }
  }
</script>

<style scoped>

</style>
